var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharebuttonMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    zoomAndPan: "magnify",
    viewBox: "0 0 135 135.000003",
    height: 180,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4f2e329597"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.496094 0 L 134.503906 0 L 134.503906 134.007812 L 0.496094 134.007812 Z M 0.496094 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8102424a79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.898438 21.4375 L 121.101562 21.4375 L 121.101562 112.261719 L 13.898438 112.261719 Z M 13.898438 21.4375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f2e329597)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.496094 0 L 134.503906 0 L 134.503906 134.007812 L 0.496094 134.007812 Z M 0.496094 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#015351",
    d: "M 0.496094 0 L 134.503906 0 L 134.503906 134.007812 L 0.496094 134.007812 Z M 0.496094 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8102424a79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 111 21.46875 L 24 21.46875 C 18.429688 21.46875 13.898438 26.003906 13.898438 31.570312 L 13.898438 102.429688 C 13.898438 107.996094 18.429688 112.53125 24 112.53125 L 111 112.53125 C 116.570312 112.53125 121.101562 107.996094 121.101562 102.429688 L 121.101562 31.570312 C 121.101562 26.003906 116.570312 21.46875 111 21.46875 Z M 22.117188 31.570312 C 22.117188 30.546875 22.976562 29.691406 24 29.691406 L 111 29.691406 C 112.023438 29.691406 112.882812 30.546875 112.882812 31.570312 L 112.882812 32.882812 L 68.46875 77.296875 C 67.941406 77.824219 67.058594 77.824219 66.53125 77.296875 L 22.117188 32.882812 Z M 112.882812 102.441406 C 112.882812 103.464844 112.023438 104.324219 111 104.324219 L 24 104.324219 C 22.976562 104.324219 22.117188 103.464844 22.117188 102.441406 L 22.117188 44.5 L 60.710938 83.09375 C 62.515625 84.898438 64.925781 85.902344 67.488281 85.902344 C 70.054688 85.902344 72.464844 84.910156 74.269531 83.09375 L 112.859375 44.5 L 112.859375 102.441406 Z M 112.882812 102.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharebuttonMailIcon);
export default __webpack_public_path__ + "static/media/sharebutton_mail_icon.92bf2852a42d72466d30028865577967.svg";
export { ForwardRef as ReactComponent };